var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBlackClose2({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12 2C10.0222 2 8.0888 2.58648 6.44431 3.68529C4.79982 4.78411 3.5181 6.34593 2.76122 8.17319C2.00434 10.0004 1.8063 12.0111 2.19215 13.9509C2.578 15.8907 3.53039 17.6726 4.92892 19.0711C6.32744 20.4696 8.10928 21.422 10.0491 21.8079C11.9889 22.1937 13.9996 21.9957 15.8268 21.2388C17.6541 20.4819 19.2159 19.2002 20.3147 17.5557C21.4135 15.9112 22 13.9778 22 12C22 9.34784 20.9464 6.80428 19.0711 4.92892C17.1957 3.05356 14.6522 2 12 2ZM14.963 13.1111H9.03704C8.74235 13.1111 8.45973 12.9941 8.25136 12.7857C8.04298 12.5773 7.92593 12.2947 7.92593 12C7.92593 11.7053 8.04298 11.4227 8.25136 11.2143C8.45973 11.0059 8.74235 10.8889 9.03704 10.8889H14.963C15.2576 10.8889 15.5403 11.0059 15.7486 11.2143C15.957 11.4227 16.0741 11.7053 16.0741 12C16.0741 12.2947 15.957 12.5773 15.7486 12.7857C15.5403 12.9941 15.2576 13.1111 14.963 13.1111Z",
    fill: "#23242A"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBlackClose2);
export default __webpack_public_path__ + "static/media/black-close-2.0e3edd5a3161c471b70328db1e3d69ee.svg";
export { ForwardRef as ReactComponent };